<!-- phone-input.component.html -->
<div class="phone-input-container">
  <div class="country-select" (click)="toggleDropdown()" [class.open]="showDropdown">
    <span class="flag">{{ selectedCountry.emoji }}</span>
    <span class="country-code">{{ selectedCountry.dial_code }}</span>
    <span class="chevron">▼</span>
    
    <div class="country-dropdown" *ngIf="showDropdown">
      <div class="search-container">
        <input type="text" 
               class="phone-number"
               placeholder="Search country..."
               [(ngModel)]="searchQuery"
               (click)="$event.stopPropagation()">
      </div>
      <div class="country-list">
        <div class="country-option" 
             *ngFor="let country of filteredCountries"
             (click)="selectCountry(country)">
          <span class="flag">{{ country.emoji }}</span>
          <span class="country-name">{{ country.name }}</span>
          <span class="country-code">+{{ country.code }}</span>
        </div>
      </div>
    </div>
  </div>
  
  <input type="tel" 
         class="phone-number" 
         [(ngModel)]="phoneNumber"
         (ngModelChange)="onPhoneNumberChange()">
</div>